import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { TravelStatusUpdateEffects } from './effects/travel-status-update.effects';

/**
 * Registers the travel-status-update effects. There is no feature state and no reducer: the slice
 * owns no data, it only orchestrates writes to the notification and timesheet slices and the OData
 * save. Nothing is persisted or hydrated.
 */
@NgModule({
    imports: [EffectsModule.forFeature([TravelStatusUpdateEffects])],
})
export class TravelStatusUpdateStoreModule {}
